import React from "react";

import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";
import StyledTableRow from "app/Components/Tables/StyledTableRow";

import { useNavigate } from "react-router-dom";
import { createSortedKeyMap } from "utils/helperFunctions";

// Player data interface
interface PlayerData {
  displayName: string;
  timeStamp: any;
  [key: string]: any;
}

// Props interfaces
interface WaitlistTableBodyProps {
  currentPlayers: Record<string, boolean>;
  playerlist: Record<string, PlayerData>;
}

interface PlayersInGameProps {
  currentPlayers: Record<string, boolean>;
  playerlist: Record<string, PlayerData>;
}

const useStyles = makeStyles({
  accordionHeader: {
    textAlign: "center",
  },
  table: {},
  clickAble: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const WaitlistTableBody = ({ currentPlayers, playerlist }: WaitlistTableBodyProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const SortedMap = createSortedKeyMap(playerlist, "timeStamp");
  const waitKeys = Object.keys(SortedMap);
  return (
    <TableBody>
      {waitKeys.map((id) => {
        if (!currentPlayers[id]) return;
        const playerData = SortedMap[id];
        if (!playerData) return;
        return (
          <StyledTableRow key={id}>
            <PrimaryTableCell
              align="center"
              //   todo make profile clickable only for actual players
              onClick={() => navigate(`../profile/${id}`)}
              className={classes.clickAble}
            >
              {playerData.displayName}
            </PrimaryTableCell>
          </StyledTableRow>
        );
      })}
    </TableBody>
  );
};

const PlayersInGame = ({ currentPlayers, playerlist }: PlayersInGameProps) => {
  return (
    <Table>
      <WaitlistTableBody
        currentPlayers={currentPlayers}
        playerlist={playerlist}
      />
    </Table>
  );
};

export default PlayersInGame;
